import { useContext } from 'react';
import { MultiFileUploadContext } from 'dash-ui';
import {
  FileUploadInput,
  useCreateMediaFileMutation,
  BrandingTypeEnum,
} from 'gql/generated.graphql';

interface IVariables {
  fileUpload: FileUploadInput;
  mediaFolderId?: string;
  propertyId: string;
  brandingType?: BrandingTypeEnum;
}

export const useUploadMediaFile = () => {
  const [createMediaFile] = useCreateMediaFileMutation();
  const { setAbortHandler, onError, onCompleted } = useContext(
    MultiFileUploadContext
  );

  return (variables: IVariables) => {
    const progressTrackingId = variables.fileUpload.progressTrackingId;

    createMediaFile({
      variables: { input: variables },
      onError: () => progressTrackingId && onError(progressTrackingId),
      onCompleted: () => progressTrackingId && onCompleted(progressTrackingId),
      context: {
        fetchOptions: {
          useUpload: false,
          onAbort: (abortHandler: () => void) =>
            progressTrackingId &&
            setAbortHandler(progressTrackingId, abortHandler),
        },
      },
    });
  };
};
